/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Member_TitleInputs */



/**
* | output |
* | --- |
* | "New member" |
*
* @param {Team_Manager_Add_Member_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_member_title = /** @type {((inputs?: Team_Manager_Add_Member_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Member_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau membre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Mitglied")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo membro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый участник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo miembro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいメンバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया सदस्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo membro")
	return /** @type {LocalizedString} */ ("New member")
});